import React from "react";

// Marca oficial do Vitalis — "V" alto em ouro com ramo de louro e uma
// fagulha, portada de vitalisfrontend/src/components/VitalisLogo.jsx
// para manter a identidade visual real do produto (o SVG genérico usado
// antes aqui não era o logo de verdade).
function VitalisLogo({ size = 32, className = "" }) {
  const gid = "vg-" + size;
  return (
    <svg
      className={`vitalis-logo ${className}`}
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Vitalis"
    >
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#A9791F" />
          <stop offset="0.45" stopColor="#EBD08A" />
          <stop offset="0.7" stopColor="#C9A227" />
          <stop offset="1" stopColor="#9A6E1C" />
        </linearGradient>
      </defs>
      <path d="M22 24 L54 100 L86 24 L74 24 L54 74 L34 24 Z" fill={`url(#${gid})`} />
      <path d="M70 96 C 80 78 86 54 82 30" stroke={`url(#${gid})`} strokeWidth="2" fill="none" strokeLinecap="round" />
      <g fill={`url(#${gid})`}>
        <path d="M82 30 c 7 -3 12 -8 13 -16 c -8 1 -13 5 -15 12 z" />
        <path d="M80 44 c 8 -2 13 -7 15 -15 c -8 0 -14 4 -17 11 z" />
        <path d="M77 58 c 8 -1 14 -6 17 -14 c -8 -1 -15 3 -18 10 z" />
        <path d="M74 72 c 8 0 15 -5 18 -13 c -8 -1 -15 2 -19 9 z" />
        <path d="M72 85 c 7 1 14 -3 18 -11 c -8 -2 -14 0 -19 7 z" />
      </g>
      <path d="M91 20 l1.6 4.2 4.2 1.6 -4.2 1.6 -1.6 4.2 -1.6 -4.2 -4.2 -1.6 4.2 -1.6 z" fill="#F2E4B8" />
    </svg>
  );
}

export default VitalisLogo;
